import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-red-100 text-red-700 px-4 py-3 rounded text-center" }




export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorMessage',
  props: {
    message: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Error:", -1)),
    _createTextVNode(" " + _toDisplayString(_ctx.message), 1)
  ]))
}
}

})